<template>
  <div>
    <div class="wrap">
      <div class="left">
        <span>{{ title }}</span>
        <h4 class="amount">{{ totalCount }}</h4>
      </div>
      <div class="right" v-if="showArea">
        <area-select-picker :currentArea="currentArea" :areaList="areaList" @handleAreaChange="handleAreaChange" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  Button,
  Popup,
  Picker
} from 'vant'
import AreaSelectPicker from '@/components/analyse/area-select-picker'

export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    AreaSelectPicker
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    areaList: {
      type: Array,
      default() {
        return []
      }
    },
    currentArea: {
      type: String,
      default: ''
    },
    totalCount: {
      type: [Number, String],
      default: 0
    },
    showArea: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPicker: false
    }
  },
  methods: {
    handleAreaChange(area) {
      this.showPicker = false
      this.$emit('handleAreaChange', area)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  min-height: 80px;
  padding: 14px 16px 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #4292F5;
  color: #fff;
  .left {
    width: 60%;
    .amount {
      line-height: 40px;
      font-size: 28px;
      word-break: break-all;
    }
  }
  .right {
    max-width: 40%;
    .van-button {
      width: 100%;
      .van-button__text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
